// removed by extract-text-webpack-plugin
module.exports = {"container":"_3G44M","noSpacing":"_1-Zl5"};


//////////////////
// WEBPACK FOOTER
// ./app/components/page/page.scss
// module id = 1391
// module chunks = 0